import React from 'react';
import { Tooltip } from '@trevor/ui-components';
import css from '../css/module/buttonWithClose.css';

/**
 * Functional component that allows to draw a button with some text and a close icon (x)
 *
 * @param {*} props
 * @returns
 */
const buttonWithClose = (props) => {
  return (
    <div>
      <button
        type="button"
        data-tooltip-id="fullName"
        className={`btn btn-s ${css.btnName}`}
        onClick={props.userInteraction(props.data)}
      >
        <div className={css.btnNameContainer}>
          <div className={css.btnNameContainer}>
            <span>{props.text}</span>
          </div>
          <div className={css.btnNameIconContainer}>
            <span>
              <b className="faint pull-right">×</b>
            </span>
          </div>
        </div>
      </button>
      <Tooltip id="fullName" className={css.nameTooltip} place="bottom">
        <span>{props.tooltip ? props.tooltip : props.text}</span>
      </Tooltip>
    </div>
  );
};

export default buttonWithClose;
